// extracted by mini-css-extract-plugin
export default {"wrapper":"EfficiencyField_wrapper__p-J5A","unit":"EfficiencyField_unit__hHAfU"};